{
	"v": "5.5.7",
	"meta": { "g": "LottieFiles AE 0.1.21", "a": "", "k": "", "d": "", "tc": "" },
	"fr": 30,
	"ip": 0,
	"op": 180,
	"w": 1000,
	"h": 1000,
	"nm": "plane",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "r2",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 140, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 150, "s": [100] },
								{ "t": 160, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 140,
									"s": [500, 500, 0],
									"to": [0, 53.333, 0],
									"ti": [0, -53.333, 0]
								},
								{ "t": 160, "s": [500, 820, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 140,
					"op": 320,
					"st": 140,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 0,
					"nm": "l1",
					"refId": "comp_2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 140, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 150, "s": [100] },
								{ "t": 160, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 140,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 160, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 140,
					"op": 320,
					"st": 140,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 0,
					"nm": "r2",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 110, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 120, "s": [100] },
								{ "t": 130, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 110,
									"s": [500, 500, 0],
									"to": [0, 53.333, 0],
									"ti": [0, -53.333, 0]
								},
								{ "t": 130, "s": [500, 820, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 110,
					"op": 290,
					"st": 110,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 0,
					"nm": "l2",
					"refId": "comp_3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 130, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 140, "s": [100] },
								{ "t": 150, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 130,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 150, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 130,
					"op": 310,
					"st": 130,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 0,
					"nm": "r1",
					"refId": "comp_4",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 120, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 130, "s": [100] },
								{ "t": 140, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 120,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 140, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 120,
					"op": 300,
					"st": 120,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 0,
					"nm": "l1",
					"refId": "comp_2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 110, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 120, "s": [100] },
								{ "t": 130, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 110,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 130, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 110,
					"op": 290,
					"st": 110,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 7,
					"ty": 0,
					"nm": "r2",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 80, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 90, "s": [100] },
								{ "t": 100, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 80,
									"s": [500, 500, 0],
									"to": [0, 53.333, 0],
									"ti": [0, -53.333, 0]
								},
								{ "t": 100, "s": [500, 820, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 80,
					"op": 260,
					"st": 80,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 8,
					"ty": 0,
					"nm": "l2",
					"refId": "comp_3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 100, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 110, "s": [100] },
								{ "t": 120, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 100,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 120, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 100,
					"op": 280,
					"st": 100,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 9,
					"ty": 0,
					"nm": "r1",
					"refId": "comp_4",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 90, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 100, "s": [100] },
								{ "t": 110, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 90,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 110, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 90,
					"op": 270,
					"st": 90,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 10,
					"ty": 0,
					"nm": "l1",
					"refId": "comp_2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 80, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 90, "s": [100] },
								{ "t": 100, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 80,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 100, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 80,
					"op": 260,
					"st": 80,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 11,
					"ty": 0,
					"nm": "r2",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 50, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 60, "s": [100] },
								{ "t": 70, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 50,
									"s": [500, 500, 0],
									"to": [0, 53.333, 0],
									"ti": [0, -53.333, 0]
								},
								{ "t": 70, "s": [500, 820, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 50,
					"op": 230,
					"st": 50,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 12,
					"ty": 0,
					"nm": "l2",
					"refId": "comp_3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 70, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 80, "s": [100] },
								{ "t": 90, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 70,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 90, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 70,
					"op": 250,
					"st": 70,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 13,
					"ty": 0,
					"nm": "r1",
					"refId": "comp_4",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 60, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 70, "s": [100] },
								{ "t": 80, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 60,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 80, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 60,
					"op": 240,
					"st": 60,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 14,
					"ty": 0,
					"nm": "l1",
					"refId": "comp_2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 50, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 60, "s": [100] },
								{ "t": 70, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 50,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 70, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 50,
					"op": 230,
					"st": 50,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 15,
					"ty": 0,
					"nm": "r2",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 20, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 30, "s": [100] },
								{ "t": 40, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 20,
									"s": [500, 500, 0],
									"to": [0, 53.333, 0],
									"ti": [0, -53.333, 0]
								},
								{ "t": 40, "s": [500, 820, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 20,
					"op": 200,
					"st": 20,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 16,
					"ty": 0,
					"nm": "l2",
					"refId": "comp_3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 40, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 50, "s": [100] },
								{ "t": 60, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 40,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 60, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 40,
					"op": 220,
					"st": 40,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 17,
					"ty": 0,
					"nm": "r1",
					"refId": "comp_4",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 30, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 40, "s": [100] },
								{ "t": 50, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 30,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 50, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 30,
					"op": 210,
					"st": 30,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 18,
					"ty": 0,
					"nm": "l1",
					"refId": "comp_2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 20, "s": [0] },
								{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 30, "s": [100] },
								{ "t": 40, "s": [0] }
							],
							"ix": 11
						},
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": {
							"a": 1,
							"k": [
								{
									"i": { "x": 0.667, "y": 1 },
									"o": { "x": 0.333, "y": 0 },
									"t": 20,
									"s": [500, 500, 0],
									"to": [0, 46.667, 0],
									"ti": [0, -46.667, 0]
								},
								{ "t": 40, "s": [500, 780, 0] }
							],
							"ix": 2
						},
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"w": 1000,
					"h": 1000,
					"ip": 20,
					"op": 200,
					"st": 20,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 19,
					"ty": 4,
					"nm": "plane",
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 0],
												[-0.75, -4.714],
												[-1.828, -8.731],
												[0, 0],
												[0, 0]
											],
											"o": [
												[0.741, 5.155],
												[1.78, 11.219],
												[0, 0],
												[0, 0],
												[0, 0]
											],
											"v": [
												[-40.336, 186.717],
												[-38.107, 201.539],
												[-32.708, 231.395],
												[-112.058, 245.251],
												[-113.999, 231.273]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[-22.999, 0],
												[-0.071, -32.696],
												[7.687, -109.912],
												[7.061, -27.968],
												[0.054, -0.273],
												[0, 0],
												[1.433, -3.466],
												[1.946, 7.571],
												[0.01, 0.041],
												[0.065, 0.283],
												[9.011, 128.878],
												[0.163, 5.265]
											],
											"o": [
												[22.987, 0],
												[-0.162, 5.26],
												[-9.023, 128.985],
												[-0.062, 0.276],
												[0, 0],
												[-1.942, 7.576],
												[-1.436, -3.466],
												[-0.01, -0.043],
												[-0.052, -0.295],
												[-7.062, -27.987],
												[-7.688, -109.918],
												[0.07, -32.693]
											],
											"v": [
												[0.002, -261.175],
												[42.496, -200.898],
												[31.25, 21.452],
												[5.329, 238.495],
												[5.1, 239.291],
												[5.1, 239.408],
												[0.002, 255.585],
												[-5.105, 239.413],
												[-5.115, 239.291],
												[-5.342, 238.455],
												[-31.251, 21.518],
												[-42.498, -200.901]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 2,
									"ty": "sh",
									"ix": 3,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 0],
												[0, 0],
												[0, 0],
												[-1.776, 11.219],
												[-0.728, 5.155]
											],
											"o": [
												[0, 0],
												[0, 0],
												[1.836, -8.731],
												[0.762, -4.718],
												[0, 0]
											],
											"v": [
												[113.998, 231.273],
												[112.043, 245.251],
												[32.699, 231.395],
												[38.094, 201.539],
												[40.323, 186.717]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 3",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 3,
									"ty": "sh",
									"ix": 4,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 6.921],
												[6.921, 0],
												[0, 0],
												[0, 0],
												[0, 0],
												[-1.996, -32.035],
												[0, 0],
												[0, -6.916],
												[-6.921, 0],
												[0, 0],
												[-0.599, -8.303],
												[-4.07, -33.816],
												[0, 0],
												[-0.695, -4.969],
												[0, 0],
												[-2.749, -1.999],
												[-2.631, 0],
												[-0.714, 0.122],
												[0, 0],
												[-11.398, 0],
												[-6.949, 21.806],
												[0, 0],
												[-0.714, 0],
												[-2.152, 1.57],
												[-0.465, 3.367],
												[0, 0],
												[4.292, 2.595],
												[0, 0],
												[-3.479, 47.477],
												[-0.568, 8.277],
												[0, 0],
												[0, 6.921],
												[0, 0],
												[5.416, 1.515],
												[0, 0],
												[1.859, -6.669],
												[-6.666, -1.87],
												[0, 0],
												[0, 0],
												[0, 0],
												[-1.307, 27.114],
												[0, 0],
												[-1.121, 0],
												[-1.551, 5.53],
												[6.665, 1.867],
												[0, 0],
												[-0.017, 0.582],
												[0, 0],
												[37.246, 0],
												[0, -47.153],
												[0, 0],
												[-1.909, -42.868],
												[0, 0],
												[0, -5.619],
												[0, 0],
												[-6.919, 0],
												[0, 0]
											],
											"o": [
												[0, -6.916],
												[0, 0],
												[0, 0],
												[0, 0],
												[1.294, 27.114],
												[0, 0],
												[-6.921, 0],
												[0, 6.921],
												[0, 0],
												[0.556, 8.277],
												[3.482, 47.477],
												[0, 0],
												[-4.289, 2.595],
												[0, 0],
												[0.475, 3.367],
												[2.162, 1.57],
												[0.719, 0],
												[0, 0],
												[6.95, 21.806],
												[11.383, 0],
												[0, 0],
												[0.723, 0.122],
												[2.639, 0],
												[2.746, -1.999],
												[0, 0],
												[0.694, -4.969],
												[0, 0],
												[4.076, -33.816],
												[0.612, -8.303],
												[0, 0],
												[6.921, 0],
												[0, 0],
												[0, -5.619],
												[0, 0],
												[-6.652, -1.865],
												[-1.872, 6.662],
												[0, 0],
												[0, 0],
												[0, 0],
												[2.009, -32.035],
												[0, 0],
												[1.131, 0.314],
												[5.478, 0],
												[1.867, -6.665],
												[0, 0],
												[1.908, -42.868],
												[0, 0],
												[0, -47.153],
												[-37.258, 0],
												[0, 0],
												[0.014, 0.582],
												[0, 0],
												[-5.413, 1.515],
												[0, 0],
												[0, 6.921],
												[0, 0],
												[6.921, 0]
											],
											"v": [
												[-201.835, -0.001],
												[-214.359, -12.53],
												[-308.22, -12.53],
												[-308.22, -33.978],
												[-63.56, -102.522],
												[-58.621, -12.53],
												[-120.079, -12.53],
												[-132.606, -0.001],
												[-120.079, 12.529],
												[-56.989, 12.529],
												[-55.247, 37.411],
												[-43.887, 159.581],
												[-134.029, 214.109],
												[-139.953, 226.564],
												[-135.079, 261.557],
												[-130.048, 269.954],
												[-122.672, 272.356],
												[-120.52, 272.176],
												[-26.506, 255.75],
												[0.002, 286.232],
												[26.502, 255.75],
												[120.505, 272.176],
												[122.661, 272.356],
												[130.038, 269.954],
												[135.068, 261.557],
												[139.952, 226.564],
												[134.028, 214.109],
												[43.877, 159.581],
												[55.233, 37.411],
												[56.983, 12.529],
												[320.743, 12.529],
												[333.277, -0.001],
												[333.277, -43.478],
												[324.12, -55.542],
												[247.312, -77.062],
												[231.878, -68.375],
												[240.561, -52.929],
												[308.217, -33.978],
												[308.217, -12.53],
												[58.61, -12.53],
												[63.56, -102.522],
												[160.749, -75.291],
												[164.135, -74.824],
												[176.194, -83.973],
												[167.512, -99.421],
												[64.735, -128.213],
												[67.547, -200.335],
												[67.547, -200.714],
												[0.002, -286.232],
												[-67.555, -200.714],
												[-67.555, -200.335],
												[-64.747, -128.213],
												[-324.133, -55.542],
												[-333.277, -43.478],
												[-333.277, -0.001],
												[-320.753, 12.529],
												[-214.359, 12.529]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 4",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{ "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [500.406, 499.609], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 6,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 20,
					"ty": 4,
					"nm": "Layer 11 Outlines",
					"parent": 19,
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 6.921],
												[6.924, 0],
												[0, 0],
												[0, -6.916],
												[-6.916, 0],
												[0, 0]
											],
											"o": [
												[0, -6.916],
												[0, 0],
												[-6.916, 0],
												[0, 6.921],
												[0, 0],
												[6.924, 0]
											],
											"v": [
												[22.871, 0],
												[10.335, -12.529],
												[-10.335, -12.529],
												[-22.871, 0],
												[-10.335, 12.529],
												[10.335, 12.529]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [333.026, 499.608], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 21,
					"ty": 4,
					"nm": "Layer 12 Outlines",
					"parent": 19,
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[-6.664, -1.867],
												[0, 0],
												[-1.122, 0],
												[-1.551, 5.528],
												[6.667, 1.872],
												[0, 0],
												[1.872, -6.665]
											],
											"o": [
												[0, 0],
												[1.131, 0.317],
												[5.475, 0],
												[1.864, -6.662],
												[0, 0],
												[-6.643, -1.865],
												[-1.861, 6.662]
											],
											"v": [
												[-7.491, 11.609],
												[0.727, 13.917],
												[4.111, 14.381],
												[16.172, 5.232],
												[7.489, -10.216],
												[-0.729, -12.516],
												[-16.174, -3.836]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [704.79, 422.832], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "r2f",
					"parent": 2,
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[6.924, 0],
												[0, -6.92],
												[0, 0],
												[-6.928, 0],
												[0, 6.921],
												[0, 0]
											],
											"o": [
												[-6.928, 0],
												[0, 0],
												[0, 6.921],
												[6.924, 0],
												[0, 0],
												[0, -6.92]
											],
											"v": [
												[0.005, -15.691],
												[-12.531, -3.161],
												[-12.531, 3.162],
												[0.005, 15.691],
												[12.531, 3.162],
												[12.531, -3.161]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [749.731, 627.166], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "r2",
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [749.732, 531.353, 0], "ix": 2 },
						"a": { "a": 0, "k": [749.732, 531.353, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 0],
												[6.923, 0],
												[0, -6.922],
												[0, 0],
												[-6.928, 0],
												[0, 6.914]
											],
											"o": [
												[0, -6.922],
												[-6.928, 0],
												[0, 0],
												[0, 6.914],
												[6.923, 0],
												[0, 0]
											],
											"v": [
												[12.531, -21.93],
												[0.005, -34.454],
												[-12.531, -21.93],
												[-12.531, 21.93],
												[0.005, 34.454],
												[12.531, 21.93]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [749.732, 565.807], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Layer 8 Outlines",
					"parent": 2,
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[6.921, 0],
												[0, -6.92],
												[0, 0],
												[-6.921, 0],
												[0, 6.921],
												[0, 0]
											],
											"o": [
												[-6.921, 0],
												[0, 0],
												[0, 6.921],
												[6.921, 0],
												[0, 0],
												[0, -6.92]
											],
											"v": [
												[0.002, -15.691],
												[-12.522, -3.161],
												[-12.522, 3.162],
												[0.002, 15.691],
												[12.522, 3.162],
												[12.522, -3.161]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [251.071, 627.166], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "l1",
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [251.071, 531.353, 0], "ix": 2 },
						"a": { "a": 0, "k": [251.071, 531.353, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[6.921, 0],
												[0, -6.921],
												[0, 0],
												[-6.921, 0],
												[0, 6.914],
												[0, 0]
											],
											"o": [
												[-6.921, 0],
												[0, 0],
												[0, 6.914],
												[6.921, 0],
												[0, 0],
												[0, -6.921]
											],
											"v": [
												[0.002, -34.454],
												[-12.522, -21.93],
												[-12.522, 21.931],
												[0.002, 34.454],
												[12.522, 21.931],
												[12.522, -21.93]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [251.071, 565.807], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_3",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "l2f",
					"parent": 2,
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[6.921, 0],
												[0, -6.916],
												[0, 0],
												[-6.92, 0],
												[0, 6.923],
												[0, 0]
											],
											"o": [
												[-6.92, 0],
												[0, 0],
												[0, 6.923],
												[6.921, 0],
												[0, 0],
												[0, -6.916]
											],
											"v": [
												[-0.004, -22.736],
												[-12.53, -10.206],
												[-12.53, 10.204],
												[-0.004, 22.736],
												[12.53, 10.204],
												[12.53, -10.206]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [336.272, 655.508], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "l2",
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [336.267, 531.353, 0], "ix": 2 },
						"a": { "a": 0, "k": [336.267, 531.353, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 0],
												[6.922, 0],
												[0, -6.922],
												[0, 0],
												[-6.92, 0],
												[0, 6.919]
											],
											"o": [
												[0, -6.922],
												[-6.92, 0],
												[0, 0],
												[0, 6.919],
												[6.922, 0],
												[0, 0]
											],
											"v": [
												[12.53, -32.581],
												[-0.004, -45.104],
												[-12.53, -32.581],
												[-12.53, 32.577],
												[-0.004, 45.104],
												[12.53, 32.577]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [336.271, 576.458], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_4",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Layer 6 Outlines",
					"parent": 2,
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [500, 500, 0], "ix": 2 },
						"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[6.917, 0],
												[0, -6.916],
												[0, 0],
												[-6.923, 0],
												[0, 6.923],
												[0, 0]
											],
											"o": [
												[-6.923, 0],
												[0, 0],
												[0, 6.923],
												[6.917, 0],
												[0, 0],
												[0, -6.916]
											],
											"v": [
												[-0.002, -22.736],
												[-12.533, -10.206],
												[-12.533, 10.204],
												[-0.002, 22.736],
												[12.532, 10.204],
												[12.532, -10.206]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [664.538, 655.508], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "r1",
					"sr": 1,
					"ks": {
						"o": { "a": 0, "k": 100, "ix": 11 },
						"r": { "a": 0, "k": 0, "ix": 10 },
						"p": { "a": 0, "k": [664.538, 531.353, 0], "ix": 2 },
						"a": { "a": 0, "k": [664.538, 531.353, 0], "ix": 1 },
						"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[0, 0],
												[6.917, 0],
												[0, -6.922],
												[0, 0],
												[-6.923, 0],
												[0, 6.919]
											],
											"o": [
												[0, -6.922],
												[-6.923, 0],
												[0, 0],
												[0, 6.919],
												[6.917, 0],
												[0, 0]
											],
											"v": [
												[12.532, -32.581],
												[-0.002, -45.104],
												[-12.533, -32.581],
												[-12.533, 32.577],
												[-0.002, 45.104],
												[12.532, 32.577]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": { "a": 0, "k": [0.027473616133, 0.022835559471, 0.024243848464, 1], "ix": 4 },
									"o": { "a": 0, "k": 100, "ix": 5 },
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": { "a": 0, "k": [664.538, 576.458], "ix": 2 },
									"a": { "a": 0, "k": [0, 0], "ix": 1 },
									"s": { "a": 0, "k": [100, 100], "ix": 3 },
									"r": { "a": 0, "k": 0, "ix": 6 },
									"o": { "a": 0, "k": 100, "ix": 7 },
									"sk": { "a": 0, "k": 0, "ix": 4 },
									"sa": { "a": 0, "k": 0, "ix": 5 },
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 190,
					"st": 0,
					"bm": 0
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "main",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": {
					"a": 1,
					"k": [
						{
							"i": { "x": 0.833, "y": 0.912 },
							"o": { "x": 0.333, "y": 0 },
							"t": 0,
							"s": [500, 1332, 0],
							"to": [0, -139.333, 0],
							"ti": [0, 139.667, 0]
						},
						{
							"i": { "x": 0.833, "y": 1 },
							"o": { "x": 0.167, "y": 0.708 },
							"t": 19,
							"s": [500, 496, 0],
							"to": [0, -139.667, 0],
							"ti": [0, 6, 0]
						},
						{
							"i": { "x": 0.667, "y": 1 },
							"o": { "x": 0.361, "y": 0 },
							"t": 41,
							"s": [500, 494, 0],
							"to": [0, -6, 0],
							"ti": [0, -1, 0]
						},
						{
							"i": { "x": 0.667, "y": 1 },
							"o": { "x": 0.333, "y": 0 },
							"t": 60,
							"s": [500, 460, 0],
							"to": [0, 1, 0],
							"ti": [0, 0, 0]
						},
						{
							"i": { "x": 0.667, "y": 1 },
							"o": { "x": 0.333, "y": 0 },
							"t": 80,
							"s": [500, 500, 0],
							"to": [0, 0, 0],
							"ti": [0, 0, 0]
						},
						{
							"i": { "x": 0.667, "y": 1 },
							"o": { "x": 0.333, "y": 0 },
							"t": 100,
							"s": [500, 460, 0],
							"to": [0, 0, 0],
							"ti": [0, 12.167, 0]
						},
						{
							"i": { "x": 0.882, "y": 1 },
							"o": { "x": 0.18, "y": 0 },
							"t": 120,
							"s": [500, 500, 0],
							"to": [0, -12.167, 0],
							"ti": [0, 141.333, 0]
						},
						{
							"i": { "x": 0.667, "y": 1 },
							"o": { "x": 0.333, "y": 0 },
							"t": 139,
							"s": [500, 387, 0],
							"to": [0, -141.333, 0],
							"ti": [0, 122.5, 0]
						},
						{ "t": 167, "s": [500, -348, 0] }
					],
					"ix": 2
				},
				"a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"w": 1000,
			"h": 1000,
			"ip": 0,
			"op": 180,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
}
